import React from 'react';

// SettingsPage Component
// This page provides application settings and configuration options
export const SettingsPage: React.FC = () => {
  return (
    <div className="p-6 bg-white rounded-lg shadow-sm border border-slate-200">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-slate-900">Settings</h1>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* General Settings Card */}
        <div className="bg-white rounded-lg border border-slate-200 p-6 shadow-sm">
          <h2 className="text-lg font-semibold text-slate-800 mb-4">General Settings</h2>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-slate-600 mb-1">Application Name</label>
              <input
                type="text"
                defaultValue="Tunas Haruman PM"
                className="w-full px-3 py-2 border border-slate-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-600 mb-1">Default Language</label>
              <select
                defaultValue="en"
                className="w-full px-3 py-2 border border-slate-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
              >
                <option value="en">English</option>
                <option value="id">Bahasa Indonesia</option>
              </select>
            </div>
          </div>
        </div>

        {/* User Preferences Card */}
        <div className="bg-white rounded-lg border border-slate-200 p-6 shadow-sm">
          <h2 className="text-lg font-semibold text-slate-800 mb-4">User Preferences</h2>
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <label className="text-sm font-medium text-slate-600">Dark Mode</label>
              <input type="checkbox" className="rounded border-slate-300 text-primary-600 focus:ring-primary-500" />
            </div>
            <div className="flex items-center justify-between">
              <label className="text-sm font-medium text-slate-600">Notifications</label>
              <input type="checkbox" className="rounded border-slate-300 text-primary-600 focus:ring-primary-500" />
            </div>
            <div className="flex items-center justify-between">
              <label className="text-sm font-medium text-slate-600">Email Alerts</label>
              <input type="checkbox" className="rounded border-slate-300 text-primary-600 focus:ring-primary-500" />
            </div>
          </div>
        </div>

        {/* API Configuration Card */}
        <div className="bg-white rounded-lg border border-slate-200 p-6 shadow-sm">
          <h2 className="text-lg font-semibold text-slate-800 mb-4">API Configuration</h2>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-slate-600 mb-1">API Base URL</label>
              <input
                type="text"
                defaultValue={import.meta.env.VITE_API_URL || 'https://api.tunasharuman-pm.com'}
                className="w-full px-3 py-2 border border-slate-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-600 mb-1">API Timeout (ms)</label>
              <input
                type="number"
                defaultValue="5000"
                className="w-full px-3 py-2 border border-slate-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
              />
            </div>
          </div>
        </div>

        {/* Feature Flags Card */}
        <div className="bg-white rounded-lg border border-slate-200 p-6 shadow-sm md:col-span-2">
          <h2 className="text-lg font-semibold text-slate-800 mb-4">Feature Flags</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="flex items-center justify-between">
              <label className="text-sm font-medium text-slate-600">Analytics</label>
              <input type="checkbox" className="rounded border-slate-300 text-primary-600 focus:ring-primary-500" />
            </div>
            <div className="flex items-center justify-between">
              <label className="text-sm font-medium text-slate-600">Error Tracking</label>
              <input type="checkbox" className="rounded border-slate-300 text-primary-600 focus:ring-primary-500" />
            </div>
            <div className="flex items-center justify-between">
              <label className="text-sm font-medium text-slate-600">Offline Support</label>
              <input type="checkbox" className="rounded border-slate-300 text-primary-600 focus:ring-primary-500" />
            </div>
            <div className="flex items-center justify-between">
              <label className="text-sm font-medium text-slate-600">Debug Mode</label>
              <input type="checkbox" className="rounded border-slate-300 text-primary-600 focus:ring-primary-500" />
            </div>
          </div>
        </div>

        {/* Save Button */}
        <div className="flex justify-end col-span-full">
          <button
            type="button"
            className="px-4 py-2 bg-primary-600 text-white text-sm font-medium rounded-md shadow-sm hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-colors"
          >
            Save Settings
          </button>
        </div>
      </div>
    </div>
  );
};